import { current } from 'immer';
import React, { useContext, useState, FC, useEffect } from 'react';
import InputData from '../Model/InputData';
import MapService from '../services/MapService';
import { UseConfigContext } from "./ConfigContext";
import SalarySimService from '../services/SalarySimService';
import { UseTranslationContext } from './TranslationContext';
import SalarySimInputPostData from '../Model/SalarySimInputPostData';
import ResultData from '../Model/ResultData';
import { isTemplateSpan } from 'typescript';
import { UseCodeListContext } from './CodeListContext';

interface ISalarySimContext {
    isSimpleSimulationMode: boolean;
    salarySimFormData: InputData,
    salarySimAdvancedFormData: InputData,
    updateSalarySimData?: (salData: InputData, currentStep: number, simpleSalarySim: boolean) => void,
    ToggleSimulationMode?: (useSimpleMode: boolean) => void
    salarySimInputMappedData: SalarySimInputPostData,
    salarySimResultData: ResultData,
    UpdateSalarySimMappedData: (mappedData: SalarySimInputPostData) => void,
    UpdateSalarySimResultData: (resultData: ResultData) => void,
    CallbackPrestaLoaded: () => void,
    SetIdAgent: (idAgent: string) => void
}

const defaultSalarySimContext = {
    isSimpleSimulationMode: true,
    salarySimFormData: new InputData(),
    salarySimAdvancedFormData: new InputData(),
    salarySimInputMappedData: new SalarySimInputPostData(),
    salarySimResultData: new ResultData(),
    UpdateSalarySimMappedData: (mappedData: SalarySimInputPostData) => { },
    UpdateSalarySimResultData: (resultData: ResultData) => { },
    CallbackPrestaLoaded: () => {},
    SetIdAgent: (idAgent: string) => {}
}

interface ISalarySimProvider {
    children?: React.ReactNode,
}


const SalarySimContext = React.createContext<ISalarySimContext>(defaultSalarySimContext);
export const UseSalarySimContext = () => useContext(SalarySimContext);

export const SalarySimContextProvider: FC<ISalarySimProvider> = ({ children }) => {
    const [salarySimFormData, setSalarySimData] = useState(defaultSalarySimContext.salarySimFormData);
    const [salarySimAdvancedFormData, setSalarySimAdvancedFormData] = useState(defaultSalarySimContext.salarySimAdvancedFormData);

    const [isSimpleSimulationMode, setIsSimpleSimulationMode] = useState(defaultSalarySimContext.isSimpleSimulationMode);

    const [isProcessingRequest, setIsProcessingRequest] = useState(false);

    const [salarySimInputMappedData, setSalarySimInputMappedData] = useState(defaultSalarySimContext.salarySimInputMappedData);
    const [salarySimResultData, setSalarySimResultData] = useState(defaultSalarySimContext.salarySimResultData);

    const updateSalarySimData = (params: InputData, currentStep: number, simpleSalarySim: boolean) => {
        
        switch(currentStep)
        {
            case 0 : // all at once
                salarySimAdvancedFormData.loadFromPresta = true;
                UpdateStep1Data(salarySimAdvancedFormData, params, false);
                UpdateStep2Data(salarySimAdvancedFormData, params, false);
                UpdateStep3Data(salarySimAdvancedFormData, params, false);

                let tempCopy = structuredClone(salarySimAdvancedFormData);
                setSalarySimAdvancedFormData(tempCopy);
            break;
            case 1 : 
                UpdateStep1Data(simpleSalarySim?salarySimFormData:salarySimAdvancedFormData, params, simpleSalarySim);;
            break;
            case 2:
                UpdateStep2Data(simpleSalarySim?salarySimFormData:salarySimAdvancedFormData, params, simpleSalarySim);
            break;
            case 3: 
                UpdateStep3Data(simpleSalarySim?salarySimFormData:salarySimAdvancedFormData, params, simpleSalarySim);
            break;
        }


        //simpleSalarySim ? setSalarySimData(salarySimFormData) : setSalarySimAdvancedFormData(salarySimAdvancedFormData);
    }

    const ToggleSimulationMode = (useSimple: boolean) => {
        setIsSimpleSimulationMode(useSimple);
    }

    const UpdateSalarySimMappedData = (mappedData: SalarySimInputPostData) => {
        setSalarySimInputMappedData(mappedData);
    }

    const UpdateSalarySimResultData = (resultData: ResultData) => {
        setSalarySimResultData(resultData); 
    }

    const UpdateStep1Data = (tempCopy: InputData, params: InputData, simpleSalarySim: boolean) => {
        tempCopy.Period = params.Period;
        tempCopy.EstablishmentUnit = params.EstablishmentUnit;
        tempCopy.HomeRegionCode = params.HomeRegionCode;
        tempCopy.HiringType=params.HiringType;
        tempCopy.MaritalStatus=params.MaritalStatus;
        tempCopy.Spouse=params.Spouse;
        tempCopy.Disabled=params.Disabled;
        tempCopy.DisabledSpouse=params.DisabledSpouse;
        tempCopy.BirthDate=params.BirthDate;

        // dependents
        tempCopy.Dependant = params.Dependant;

        tempCopy.DependantChildren = params.DependantChildren;
        tempCopy.DisabledDependantChildren = params.DisabledDependantChildren;

        tempCopy.OthersDependant = params.OthersDependant;
        tempCopy.OthersDisabledDependant = params.OthersDisabledDependant;

        tempCopy.More65TransitionalMeasureDependant = params.More65TransitionalMeasureDependant;
        tempCopy.More65TransitionalMeasureDisabledDependant = params.More65TransitionalMeasureDisabledDependant;

        tempCopy.More65DependanceSituationDependant = params.More65DependanceSituationDependant;
        tempCopy.More65DependanceSituationDisabledDependant = params.More65DependanceSituationDisabledDependant;

        if(!simpleSalarySim)
        {
            tempCopy.UserName = params.UserName;   
            
        }

        return tempCopy;
    }

    const UpdateStep2Data = (tempCopy: InputData, params: InputData, simpleSalarySim: boolean) => {
        tempCopy.ContractType = params.ContractType;
        //step 2 simple
        if(simpleSalarySim){
      
            tempCopy.NetToBrut = params.NetToBrut;
            tempCopy.MonthlyAmount = params.MonthlyAmount;
            tempCopy.CollectiveInsuranceAmount = params.CollectiveInsuranceAmount;

        }else{
        //step 2 advanced 

            tempCopy.JointCommittee = params.JointCommittee;
            tempCopy.NumberEmployees = params.NumberEmployees;
            tempCopy.OnssSubmitted = params.OnssSubmitted;
            tempCopy.OnssPrefix = params.OnssPrefix;
            tempCopy.ProfDeductionSubmitted = params.ProfDeductionSubmitted;
            tempCopy.PartTime = params.PartTime;
            tempCopy.SecondaryActivity=params.SecondaryActivity;

            tempCopy.MondaySchedule = params.MondaySchedule;
            tempCopy.TuesdaySchedule = params.TuesdaySchedule;
            tempCopy.WednesdaySchedule = params.WednesdaySchedule;
            tempCopy.ThursdaySchedule = params.ThursdaySchedule;
            tempCopy.FridaySchedule = params.FridaySchedule;
            tempCopy.SaturdaySchedule = params.SaturdaySchedule;
            tempCopy.SundaySchedule = params.SundaySchedule;

            tempCopy.MondayScheduleRef = params.MondayScheduleRef;
            tempCopy.TuesdayScheduleRef = params.TuesdayScheduleRef;
            tempCopy.WednesdayScheduleRef = params.WednesdayScheduleRef;
            tempCopy.ThursdayScheduleRef = params.ThursdayScheduleRef;
            tempCopy.FridayScheduleRef = params.FridayScheduleRef;
            tempCopy.SaturdayScheduleRef = params.SaturdayScheduleRef;
            tempCopy.SundayScheduleRef = params.SundayScheduleRef;
        }

        return tempCopy;
    }

    const UpdateStep3Data = (tempCopy: InputData, params: InputData, simpleSalarySim: boolean) => {

        tempCopy.NetToBrut = params.NetToBrut;
        tempCopy.MonthlyAmount = params.MonthlyAmount;
        tempCopy.GrossSubmittedAmount = params.GrossSubmittedAmount;
        tempCopy.NetToBrut=params.NetToBrut;
        tempCopy.ProfDeductionAmount=params.ProfDeductionAmount;
        tempCopy.NetBenefitAmount=params.NetBenefitAmount;
        tempCopy.NetCarBenefitAmount=params.NetCarBenefitAmount;
        tempCopy.HasWorkHomeBenefit=params.HasWorkHomeBenefit;
        tempCopy.CollectiveInsuranceAmount=params.CollectiveInsuranceAmount;
        tempCopy.OtherNegativeAmount=params.OtherNegativeAmount;
        tempCopy.OtherPositiveAmount=params.OtherPositiveAmount;
        tempCopy.CollectiveInsuranceEmployeurIntervAmount=params.CollectiveInsuranceEmployeurIntervAmount;
        tempCopy.Commissions=params.Commissions;
        tempCopy.EndYearBonusAmount=params.EndYearBonusAmount;
        tempCopy.EndYearBonusAmountForemNotSubmitted=params.EndYearBonusAmountForemNotSubmitted;
        tempCopy.EndYearBonusAmountForemSubmitted=params.EndYearBonusAmountForemSubmitted;
        tempCopy.NonReccurentDirectorAmount=params.NonReccurentDirectorAmount;
        tempCopy.MonthlyCopyrightAmount=params.MonthlyCopyrightAmount;
           
        // PECULES
        tempCopy.CurrentDoubleBonusAmount=params.CurrentDoubleBonusAmount;
        tempCopy.CurrentAdditionalBonusAmount=params.CurrentAdditionalBonusAmount;
        tempCopy.PreviousBonusAmount=params.PreviousBonusAmount;
        tempCopy.PreviousDoubleBonusAmount=params.PreviousDoubleBonusAmount;
        tempCopy.PreviousAdditionalBonusAmount=params.PreviousAdditionalBonusAmount;
        tempCopy.AdvanceBonusAmount=params.AdvanceBonusAmount;
        tempCopy.AdvanceDoubleBonusAmount=params.AdvanceDoubleBonusAmount;
        tempCopy.AdvanceAdditionalBonusAmount=params.AdvanceAdditionalBonusAmount;

        tempCopy.PublicTransportationAmount=params.PublicTransportationAmount;
        tempCopy.PrivateTransportationAmount=params.PrivateTransportationAmount;

        return tempCopy;
    }

    const CallbackPrestaLoaded = () => {
        let tempCopy: InputData = new InputData();
        tempCopy = salarySimAdvancedFormData;

        tempCopy.loadFromPresta = false;
        setSalarySimAdvancedFormData(tempCopy);
    }

    const SetIdAgent = (userIdAgent: string) => {
        salarySimAdvancedFormData.agent = userIdAgent;
    }

    return (
        <SalarySimContext.Provider value={{
            salarySimFormData, salarySimAdvancedFormData, updateSalarySimData, isSimpleSimulationMode, ToggleSimulationMode, salarySimInputMappedData, salarySimResultData, UpdateSalarySimMappedData, UpdateSalarySimResultData, CallbackPrestaLoaded, SetIdAgent
        }}>
            {children}
        </SalarySimContext.Provider>
    )
}